import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import { logger, LogCategory } from '../../utils/logger';

const LoadingScreen: React.FC = () => {
    const [animationData, setAnimationData] = useState(null);

    useEffect(() => {
        // Load the animation data
        fetch('/assets/SportLoading.json')
            .then(response => response.json())
            .then(data => setAnimationData(data))
            .catch(err => logger.error(LogCategory.UI, 'Failed to load animation', err, 'LoadingScreen'));
    }, []);

    return (
        <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
            <div className="relative flex items-center">
                <div className="w-64 h-64 flex items-start pt-8">
                    {animationData ? (
                        <Lottie
                            animationData={animationData}
                            loop={true}
                            style={{
                                filter: 'brightness(0) saturate(100%) invert(17%) sepia(57%) saturate(1200%) hue-rotate(201deg) brightness(78%) contrast(90%)',
                                width: '100%',
                                height: '100%'
                            }}
                        />
                    ) : (
                        <div className="w-12 h-12 mx-auto animate-spin rounded-full border-4 border-gray-300 border-t-[#4764AF]"></div>
                    )}
                </div>
                <span
                    className="absolute left-48 top-1/2 transform -translate-y-1/2"
                    style={{
                        fontFamily: 'Inter, Arial, Helvetica, sans-serif',
                        fontSize: '48px',
                        fontWeight: 700,
                        letterSpacing: '-1px',
                        color: '#4764AF',
                    }}
                >
                    LATIO
                </span>
            </div>
        </div>
    );
};

export default LoadingScreen;